import Store from "./store"
import { generateGUID } from "../../common/common"
import { MediaType, RecvMagicMode } from "../../common/enums"
import audioManager from "../media/audio-manager"

class ProtocolSender {
  constructor () {
    this.cacheSendQueue = [] // 消息队列
  }
  init () {
    this.cacheSendQueue = []
  }
  sendJoinGroupReq(groupId) {
    let msg = {
      business: "GS",
      id: 14100,
      group_id: groupId
    };
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendLeaveGroupReq() {
    let msg = {
      business: "GS",
      id: 14102
    };
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendResolutionReport(websocket, params) {
    let msg = {
      business: "SS",
      id: 18004,
      stream_id: params.streamId,
      width: params.width,
      height: params.height,
      channel_type: params.channelType,
      report_type: params.reportType
    };
    Store.websocket && Store.websocket.send(JSON.stringify(msg)); // 上报到信令网关wsgw
  }
  
  sendLogoutReq(){
    let msg = {
      business: "BASE",
      id: 10002
    };
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendLoginReq(options){
    let msg = {
      business: "BASE",
      id: 10000,
      app_id: options.appId,
      company_id: options.companyId,
      token: options.token,
      user_id: options.userId,
      client_guid: generateGUID(), // FIXME：不唯一
      os_type: options.osType,
      mutex_type: options.mutexType,
      force_login: options.forceLogin, 
      registered_user: options.registered,
      protocol_version: "0.0.3",
      sdk_type: 25,
      extend_info: options.extendInfo
    };
  
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendPublishMediaReq(operation, mediaType, mediaId){
    let msg = {
      business: "GS",
      id: 14104,
      //媒体类型，0为屏幕共享，1为音频，2为视频
      media_type: mediaType,
      // TODO 如果需要发布多路流，需要传入MediaId，单路流不影响
      media_id: mediaId,
      //操作类型，0停止广播，1开启广播
      operation: operation
    };
  
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendRecvMediaReq(recvState, srcUserId, mediaType, mediaId){
    let msg = {
      business: "SS",
      id: 18002,
      group_id: Store.userInfo.groupId,
      user_id: srcUserId,
      media_type: mediaType, //媒体类型，0为屏幕共享，1为音频，2为视频
      media_id: mediaId,
      recv: recvState       //0停止接收，1开启接收
    };
  
    if (mediaType == MediaType.AUDIO) {
      // 接收变声，但media_id没有_magic后缀，则加上后缀
      if (audioManager.recvMagicAudio == RecvMagicMode.ONLY_MAGIC) {
        if (mediaId.indexOf("_magic") == -1) {
          msg.media_id = mediaId + "_magic";
        }  
      } else if (audioManager.recvMagicAudio == RecvMagicMode.ONLY_ORIGIN) { // 接收原声，但media_id有_magic后缀，则剥掉后缀
        if (mediaId.indexOf("_magic") != -1) {
          msg.media_id = mediaId.substr(0, mediaId.length - 6);
        }
      } else {
        // Do nothing
      }
    }
    // 白板属于组内资源
    if (mediaType == MediaType.WHITE_BOARD) {
      msg.media_owner = "group"
    } else {
      msg.media_owner = "user"
    }
    
    this.cacheSendQueue.push(msg)

    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendCreateWhiteboardReq(parmas) {
    let defaultParmas = {
      business: "WBS",
      id: 19000,
      cli_seq_id: 1,
      board_type: 0, 
      width: 1280, 
      height: 768,
      board_name: '',
      file_path: '',
      convert_file_path: '',
      page: 1
    }
    defaultParmas = Object.assign(defaultParmas, parmas)
    Store.websocket.send(JSON.stringify(defaultParmas));
  }
  
  sendCloseWhiteboardReq(mediaId, parmas) {
    let msg = {
      business: "WBS",
      id: 19002,
      board_id: mediaId
    };
    msg = Object.assign(msg, parmas)
    Store.websocket.send(JSON.stringify(msg));
  }
  
  sendNotifySendStreamRes(params) {
    let msg = {
      business: "SS",
      id: 18001,
      stream_id: params.streamId,
      send: params.send,
      result: params.result
    };
    Store.websocket.send(JSON.stringify(msg));
  } 

  sendLogoutRecvChannelReq(websocket, streamId) {
    let msg = {
      business: 'SS',
      id: 19012,
      stream_id: streamId,
      client_id: "{" + Store.userInfo.appId + ";" + Store.userInfo.groupId + "};" + Store.userInfo.userId
    }
    websocket.send(JSON.stringify(msg));
  }

  sendLoginRecvChannelReq(websocket, params, bindId) {
    let userId = Store.userInfo.userId || bindId
    let msg = {
      business: 'SS',
      id: 19004,
      stream_id: params.streamId,
      stream_token: params.streamToken,
      media_type: params.media_type,
      media_id: params.media_id,
      client_id: "{" + Store.userInfo.appId + ";" + Store.userInfo.groupId + "};" + userId, // 直播使用bindId
      version: "1.0.0",
      bind_id: parseInt(bindId)
    }
    websocket.send(JSON.stringify(msg));
  }

  sendSdpInfo(websocket, description, pcId) {
    let msg = {
      business: "SS",
      id: 19008,
      type: description.type,
      pc_id: pcId,
      sdp: description.sdp
    };
    websocket.send(JSON.stringify(msg));
  }

  sendCandidate(websocket, event, pcId) {
    let msg = {
      business: "SS",
      id: 19008,
      pc_id: pcId,
      candidate: event.candidate.candidate,
      sdpMid: event.candidate.sdpMid,
      sdpMLineIndex: event.candidate.sdpMLineIndex
    };
    websocket.send(JSON.stringify(msg));
  }

  sendLoginSendChannelReq(websocket, params, bindId) {
    let msg = {
      business: 'WBS',
      id: 19006,
      stream_id: params.streamId,
      stream_token: params.streamToken,
      media_type: params.mediaType,
      media_id: params.mediaId,
      client_id: Store.getClientId(),
      version: "1.0.0",
      bind_id: bindId
    }
    websocket.send(JSON.stringify(msg));
  }

  sendSetAudioMagic(websocket, streamId, value) {
    let msg = {
      business: "SS",
      id: 19010,
      stream_id: streamId,
      client_id: Store.getClientId(),
      param: [{
        param_type: "SoundTouch",
        param_value: value.toString()
      }]
    };
    websocket.send(JSON.stringify(msg));
  }

  SendSetAudioMagicReq(websocket, streamId, value) {
    let msg = {
      business: "SS",
      id: 19010,
      stream_id: streamId,
      client_id: Store.getClientId(),
      param: [{
        param_type: "SoundTouch",
        param_value: value.toString()
      }]
    };
    websocket.send(JSON.stringify(msg));
  }

  sendGetWhiteBoardFullDataReq(websocket) {
    let msg = {
      id: 30003
    };
    websocket.send(JSON.stringify(msg));
  }

  sendGetWhiteBoardFileUrlReq(filePath) {
    let msg = {
      business: 'STORE',
      id: 20006,
      file_path: filePath
    }
    Store.websocket.send(JSON.stringify(msg));
  }

  sendUserMsg(params) {
    let msg = {
      business: "SG",
      id: 11000,
      dst_user_id: params.dstUserId,
      msg_id: 1024,
      msg: params.msg
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendUserMsgAck(params) {
    let msg = {
      business: "SG",
      id: 11004,
      src_user_id: params.src_user_id,
      msg_id: params.msg_id
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendGroupMsgWithWhiteList(params) {
    let msg = {
      business: "SG",
      id: 11006,
      group_id: params.groupId,
      white_list: params.whiteList,
      msg_id: 1024,
      msg: params.msg
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendGroupMsgWithBlackList(params) {
    let msg = {
      business: "SG",
      id: 11006,
      group_id: params.groupId,
      black_list: params.blackList,
      msg_id: 1024,
      msg: params.msg
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendGroupMsg(params) {
    let msg = {
      business: "SG",
      id: 11006,
      group_id: params.groupId,
      msg_id: 1024,
      msg: params.msg
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendGroupMsgAck(params) {
    let msg = {
      business: "SG",
      id: 11010,
      group_id: params.group_id,
      src_user_id: params.src_user_id,
      msg_id: params.msg_id
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendSetCustomStateReq(customState) {
    let msg = {
      business: "PS",
      id: 12006,
      custom_state: customState
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendKickOutRes() {
    let msg = {
      business: "PS",
      id: 12008
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendGetOnlineUsersReq() {
    let msg = {
      business: "PS",
      id: 12119,
      seq_id: (Math.floor(Math.random()*4096))
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendMakeCallReq(params) {
    let msg = {
      business: "CCS",
      id: 14300,
      seq_id: params.seqId,
      group_id: params.groupId,
      callee_type: params.calleeType,
      callee_id: params.calleeId,
      extend_info: params.extendInfo
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendMakeCallRes(params) {
    let msg = {
      business: "CCS",
      id: 14303,
      call_id: params.callId,
      group_id: params.groupId,
      result: params.result,
      extend_info: params.extendInfo
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendReleaseCallRes(callId) {
    let msg = {
      business: "CCS",
      id: 14306,
      call_id: callId,
      result: 0
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendCancelCallReq(callId) {
    let msg = {
      business: "CCS",
      id: 14307,
      call_id: callId,
      extend_info: ""
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendCancelCallRes(callId) {
    let msg = {
      business: "CCS",
      id: 14310,
      call_id: callId
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendFinishCallReq(callId) {
    let msg = {
      business: "CCS",
      id: 14311,
      call_id: callId,
      extend_info: ""
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendFinshCallRes(callId) {
    let msg = {
      business: "CCS",
      id: 14314,
      call_id: callId
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendInviteReq(params, callees) {
    let msg = {
      business: "GS",
      id: 14000,
      seq_id: params.seqId,
      group_id: params.groupId,
      callee_info: callees,
      extend_info: params.extendInfo
    };
    Store.websocket.send(JSON.stringify(msg));
  }

  sendInviteReply(params) {
    let msg = {
      business: "GS",
      id: 14003,
      seq_id: params.seqId,
      group_id: params.groupId,
      operate: params.operation,
      extend_info: params.extendInfo
    };
    Store.websocket.send(JSON.stringify(msg));
  }
  sendOpenUpload ({ filename, size }) {
    let msg = {
      business: 'STORE',
      id: 20000,
      upload_id: Store.userInfo.userId,
      checksum: '',
      file_path: `/${Store.userInfo.groupId}/${filename}`,
      file_size: size,
      upload_mode: 0
    }
    Store.websocket.send(JSON.stringify(msg))
  }

  sendUploadEnd (file_path) {
    let msg = {
      business: 'STORE',
      id: 20002,
      file_path: file_path
    }
    Store.websocket.send(JSON.stringify(msg))
  }
  sendTransCodeMsg (file_path) {
    let msg = {
      business: 'DC',
      id: 21000,
      file_path: file_path
    }
    Store.websocket.send(JSON.stringify(msg))
  }

  sendCancelReplyReq(params) {
    let msg = {
      business: "GS",
      id: 14006,
      seq_id: params.seqId,
      group_id: params.groupId,
      callee_info: params.calleeInfo
    };
    Store.websocket.send(JSON.stringify(msg));
  }
  /**
   * 获取编辑
   * @param {*} websocket 
   */
  sendOpenEdit (websocket) {
    let msg = {
      id: 30001
    }
    websocket.send(JSON.stringify(msg))
  }
  sendPageInfoMsg (websocket, params) {
    let msg = {
      id: 30200,
      page: {
        pid: params.curPage,
        action: params.action
      },
      edit_id: params.edit_id,
      seq_id: params.seq_id,
      type: 'page'
    }
    websocket.send(JSON.stringify(msg))
  }
  sendGraphMsg (websocket, parmas) {
    // let msg = Object.assign({id: 31000}, parmas)
    websocket.send(JSON.stringify(parmas))
  }

  sendResolutionChangeReq(websocket, params) {
    let msg = {
      business: "SS",
      id: 19016,
      stream_id: params.streamId,
      client_id: Store.getClientId(),
      width: params.width,
      height: params.height
    };
    websocket.send(JSON.stringify(msg));
  }
  // 发送心跳

  sendHeartPacket () {
    Store.websocket.send(JSON.stringify({}));
  }
}

export default new ProtocolSender();